'use strict';exports.__esModule = true;exports.default = clearNumber;function clearNumber() {var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return value.toString().replace(/[^\d]/g, '');
}module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/clearNumber.js
// module id = 66
// module chunks = 0